function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import { Text } from "./TreeLabel";
// eslint-disable-next-line @typescript-eslint/no-empty-function
export var noop = function noop() {};
export var createSearchTreeModel = function createSearchTreeModel() {
  var separator = '#-#';

  var createKey = function createKey() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.join(separator);
  };

  var parseKey = function parseKey(key) {
    return key.split(separator);
  };

  var registerTreeContext = function registerTreeContext(_) {
    Object.assign(searchTreeContext, _);
  };

  var waiting = false;

  var rigisterTextNode = function rigisterTextNode(key, trigger) {
    if (!searchTreeContext.titleNodeMap[key] && searchTreeContext.matchText) {
      if (!waiting) {
        waiting = true;
        Promise.resolve().then(function () {
          waiting = false;
          searchTreeContext.search();
        });
      }
    }

    searchTreeContext.titleNodeMap[key] = trigger;
  };

  var removeTextNode = function removeTextNode(key) {
    delete searchTreeContext.titleNodeMap[key];

    if (!waiting) {
      waiting = true;
      Promise.resolve().then(function () {
        waiting = false;
        searchTreeContext.search();
      });
    }
  };

  var findKeyWord = function findKeyWord(matchText, ignoreCase, isNewMethod) {
    var unsafeMatchedKeys = [];
    var totalCount = 0;

    if (isNewMethod) {
      var titleNodeMap = searchTreeContext.titleNodeMap;

      var _keys = Object.keys(titleNodeMap);

      if (matchText && _keys.length > 0) {
        _keys.forEach(function (textNodeKey) {
          try {
            var _text2 = titleNodeMap[textNodeKey].label;
            var result = searchTreeContext.parse(_text2, matchText, textNodeKey, ignoreCase);

            if (result) {
              searchTreeContext.matched[textNodeKey] = result;
              unsafeMatchedKeys.push(textNodeKey);
              totalCount += result.count;
            }
          } catch (_unused) {}
        });
      }
    } else {
      var treeModel = searchTreeContext.treeModel;

      if (treeModel && matchText) {
        treeModel.dfs(treeModel.getRoot().treeNode, function (m) {
          var _m$children;

          var _findKeyWordFromTitle = findKeyWordFromTitle(matchText, treeModel, m, ignoreCase),
              _totalCount = _findKeyWordFromTitle.totalCount,
              _unsafeMatchedKeys = _findKeyWordFromTitle.unsafeMatchedKeys;

          totalCount += _totalCount;
          unsafeMatchedKeys.push.apply(unsafeMatchedKeys, _toConsumableArray(_unsafeMatchedKeys));
          return (_m$children = m.children) !== null && _m$children !== void 0 ? _m$children : [];
        });
      }
    }

    return {
      keys: unsafeMatchedKeys,
      totalCount: totalCount
    };
  };

  var findKeyWordFromTitle = function findKeyWordFromTitle(matchText, treeModel, treeNode, ignoreCase) {
    var totalCount = 0;
    var unsafeMatchedKeys = []; // 新版本新增 title 可能是一个函数，函数在节点渲染前无法获取到 虚拟dom
    // 如果是函数取函数渲染的结果，不是函数则取 title

    if (treeNode._title || typeof treeNode.title !== 'function') {
      treeModel.dfs(treeNode._title || treeNode.title, function (rn) {
        if ( /*#__PURE__*/React.isValidElement(rn)) {
          var typeName;
          var type = rn.type;

          if (type) {
            var _prism_rc_name;

            typeName = (_prism_rc_name = rn.type.__prism_rc_name) !== null && _prism_rc_name !== void 0 ? _prism_rc_name : type.__prism_rc_name;
          }

          if (typeName === 'TreeLabel') {
            try {
              var id = rn.props._id;

              var _textNodeKey = createKey(treeNode.key, id);

              var _text3 = rn.props.label;
              var result = searchTreeContext.parse(_text3, matchText, _textNodeKey, ignoreCase);

              if (result) {
                searchTreeContext.matched[_textNodeKey] = result;
                unsafeMatchedKeys.push(_textNodeKey);
                totalCount += result.count;
              }

              return [];
            } catch (_unused2) {}
          }

          var c = rn.props.children;
          if (!c || _typeof(c) !== 'object') return [];

          if (c && !Array.isArray(c)) {
            c = [c];
          }

          return c;
        }

        return [];
      });
    }

    return {
      totalCount: totalCount,
      unsafeMatchedKeys: unsafeMatchedKeys
    };
  };

  var parse = function parse(text, matchText, textNodeKey, ignoreCase) {
    var _text = text;
    var _matchText = matchText;

    if (ignoreCase) {
      _matchText = matchText.toLowerCase();
      _text = text.toLowerCase();
    }

    if (typeof matchText === 'string' && matchText.length > 0 && typeof _text === 'string' && _text.includes(_matchText)) {
      var _matchText$length;

      var children = [];
      var indexMap = {};
      var count = 0;
      var matchTextLength = (_matchText$length = matchText.length) !== null && _matchText$length !== void 0 ? _matchText$length : 0;

      while (_text) {
        var start = _text.indexOf(_matchText);

        if (start === 0) {
          var k = createKey(textNodeKey, String(children.length));
          indexMap[count] = children.length;
          count++;
          children.push({
            rcNode: /*#__PURE__*/React.createElement(Text, {
              key: k,
              k: k,
              children: text.slice(0, matchTextLength)
            }),
            highLight: noop
          });
          var end = start + matchTextLength;
          _text = _text.slice(end);
          text = text.slice(end);
        } else if (start > -1) {
          var _k = createKey(textNodeKey, String(children.length + 1));

          indexMap[count] = children.length + 1;
          count++;

          var _end = start + matchTextLength;

          children.push({
            rcNode: text.slice(0, start),
            highLight: noop
          }, {
            rcNode: /*#__PURE__*/React.createElement(Text, {
              key: _k,
              k: _k,
              children: text.slice(start, _end)
            }),
            highLight: noop
          });
          _text = _text.slice(_end);
          text = text.slice(_end);
        } else {
          children.push({
            rcNode: text,
            highLight: noop
          });
          break;
        }
      }

      return {
        children: children,
        indexMap: indexMap,
        count: count
      };
    }
  };

  var highLight = function highLight(key, isExisted) {
    if (isExisted) {
      searchTreeContext.titleNodeMap[key].updateNode();
    }
  };

  var expandNode = function expandNode(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // 节点没挂载 或者没有展开
    var treeModel = searchTreeContext.treeModel,
        parseKey = searchTreeContext.parseKey;

    if (treeModel) {
      var _parseKey = parseKey(key),
          _parseKey2 = _slicedToArray(_parseKey, 1),
          nodeKey = _parseKey2[0];

      var pModel = treeModel.getModel(nodeKey);
      if (!pModel) return;
      var animation = options.animation,
          hasDone = options.hasDone;

      var _model = treeModel.getModel(pModel.pKey);

      while (_model) {
        if (hasDone && hasDone(_model)) {
          break;
        }

        if (_model.canExpand(_model.treeNode.key) && !_model.getExpanded(_model.treeNode.key)) {
          _model.trigger({
            type: 'expand',
            expanded: true,
            currentItem: _model.treeNode,
            model: treeModel.getModel(_model.pKey),
            animation: animation
          });
        }

        _model = treeModel.getModel(_model.pKey);
      }
    }
  };

  var clearHighLight = function clearHighLight(keys) {
    keys.forEach(function (key) {
      if (searchTreeContext.titleNodeMap[key]) {
        searchTreeContext.titleNodeMap[key].updateNode(false);
      }
    });
  };

  var searchTreeContext = {
    currentKey: '',
    // 子组件挂载时根据这个判断是否高亮自己
    treeModel: undefined,
    // 组件挂载后才存在
    layout: undefined,
    // tree 的样式属性比如高度，大小
    matched: {},
    // 匹配后的 TreeLabel 的 children
    matchText: '',
    // 输入框匹配的值
    separator: separator,
    // key 分隔符
    lastSearchTime: 0,
    // 防抖定时器id
    titleNodeMap: {},
    // 注册的 Treelabel 容器
    createKey: createKey,
    parseKey: parseKey,
    registerTreeContext: registerTreeContext,
    rigisterTextNode: rigisterTextNode,
    removeTextNode: removeTextNode,
    findKeyWord: findKeyWord,
    parse: parse,
    highLight: highLight,
    clearHighLight: clearHighLight,
    expandNode: expandNode,
    search: noop
  };
  return searchTreeContext;
};